import Modal from '@mui/material/Modal';
import { IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  open: boolean;
  onClose?: () => void;
  title?: React.ReactNode;
  content: React.ReactNode;
  contentWidth?: number;
}

const GenericModal: React.FC<Props> = (props) => {
  const displayMobile = useMediaQuery('(max-width:959px)');

  const renderCorrectModalContentWidth = () => {
    if (!displayMobile) {
      if (props.contentWidth) {
        return `${props.contentWidth}%`;
      }
      return 'auto';
    }
    return 'auto';
  };

  return (
    <Modal
      aria-labelledby="generic-modal"
      aria-describedby="generic-modal"
      className="generic-modal"
      open={props.open}
      onClose={props.onClose}
    >
      <div
        className="modal-content"
        style={{
          width: renderCorrectModalContentWidth(),
        }}
      >
        <div className="modal-body">
          <div className="text-center pt-1">
            <h2>{props.title}</h2>
          </div>
          <div className="close-icon">
            <IconButton aria-label="close-modal" onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {props.content}
        </div>
      </div>
    </Modal>
  );
};

export default GenericModal;
